module.exports = __webpack_public_path__ + "img/thumbnail_RingTailedLemur_j_normal.1868e67a.png";